import { render, staticRenderFns } from "./fields-select.vue?vue&type=template&id=aa4705d8&"
import script from "./fields-select.vue?vue&type=script&lang=js&"
export * from "./fields-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports